import {
  ClaimSearchDataType,
  ClaimSearchFilterType,
  ColumnHeaderType,
} from '../../utils/Types';
import { CLICK_ACTIONS } from '../../utils/Constant';

export const actionValueGetter = (
  data: ClaimSearchDataType,
  field?: string
) => {
  if (
    !data[field as keyof ClaimSearchDataType] ||
    data[field as keyof ClaimSearchDataType] === 'null'
  ) {
    return 'View Details';
  }
};

export const getClaimsRequest = (params: {
  selectedFilter: ClaimSearchFilterType;
  currentPage: number;
  pageSize: number;
}) => {
  const { searchBy, text } = params.selectedFilter;

  const requestPayload: any = {
    claimID: '',
    policyID: '',
    mobileNo: '',
    farmerID: '',
    productName: '',
    pageNumber: params.currentPage ?? 1,
    pagePerCount: params.pageSize ?? 20,
  };

  if (searchBy?.value && text) {
    requestPayload[searchBy.value] = text;
  }

  return requestPayload;
};

export const ClaimSearchColumnHeader: ColumnHeaderType[] = [
  {
    name: 'Claim ID',
    field: 'claimNo',
    sortable: false,
    valueGetter: (data) => data.claimNo ?? 'N/A',
  },
  {
    name: 'Policy ID',
    field: 'policy.policyNumber',
    sortable: false,
    valueGetter: (data) => data.policy?.policyNumber ?? 'N/A',
  },
  {
    name: 'Farmer Name',
    field: 'policy.custmerName',
    sortable: false,
    valueGetter: (data) => data.policy?.custmerName ?? 'N/A',
  },
  {
    name: 'Farmer ID',
    field: 'policy.custemerID',
    sortable: false,
    valueGetter: (data) => data.policy?.custemerID ?? 'N/A',
  },
  {
    name: 'Mandal',
    field: 'policy.mandal',
    sortable: false,
    valueGetter: (data) => data.policy?.mandal ?? 'N/A',
  },
  {
    name: 'Village',
    field: 'policy.village',
    sortable: false,
    valueGetter: (data) => data.policy?.village ?? 'N/A',
  },
  {
    name: 'Status',
    field: 'claimStatus',
    sortable: false,
    valueGetter: (data) => data.claimStatus ?? 'N/A',
  },
  {
    name: 'Actions',
    field: 'claimsearch',
    clickable: true,
    action: CLICK_ACTIONS.CLAIM_SEARCH,
    valueGetter: actionValueGetter,
  },
];
